import { useCallback, useLayoutEffect, useRef } from 'react';

import { noop } from 'lodash';

/**
 * A Hook to define an event handler with an always-stable function identity.
 *
 * https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
 */
export function useEvent<T extends (...args: unknown[]) => unknown>(fn: T = noop as T): T {
  const ref = useRef(fn);

  // we copy a ref to the callback scoped to the current state/props on each render
  useLayoutEffect(() => {
    ref.current = fn;
  });

  return useCallback((...args: unknown[]) => ref.current.apply(null, args), []) as T;
}
